import {useEffect, useState} from "react";
import {SwitchHorizontalIcon} from "@heroicons/react/solid";

import {BUTTON_VARIANT_TYPES} from "../../../utils/constants";

import Button from "../Button";
import CheckboxCard from "./CheckboxCard";

const SELECT_TYPES = {
    CURRENT: "current",
    OPTION: "options"
};

function DualList(props) {
    const {options, current, setOptions, setCurrent, itemName, setChangesMade} = props;

    const [newCurrent, setNewCurrent] = useState([]);
    const [newOptions, setNewOptions] = useState([]);
    const [selectedAllCurrent, setSelectedAllCurrent] = useState(false);
    const [selectedAllOptions, setSelectedAllOptions] = useState(false);

    useEffect(() => {
        newCurrent.length === current.length && current.length + newCurrent.length > 0 ?
            setSelectedAllCurrent(true) : setSelectedAllCurrent(false);
        newOptions.length === options.length && options.length + newOptions.length > 0 ?
            setSelectedAllOptions(true) : setSelectedAllOptions(false);
    }, [current.length, newCurrent, newOptions, options.length]);

    const onCheckboxClick = (event, type) => {
        if (event.target === event.currentTarget) {
            if (type === SELECT_TYPES.CURRENT) {
                newCurrent.includes(event.target.id) ? setNewCurrent(newCurrent.filter(
                    item => item !== event.target.id)) :
                    setNewCurrent(state => [...state, event.target.id]);
            } else {
                newOptions.includes(event.target.id) ? setNewOptions(newOptions.filter(
                    item => item !== event.target.id)) :
                    setNewOptions(state => [...state, event.target.id]);
            }
        }
    };

    const onSelectAllClick = (type) => {
        if (type === SELECT_TYPES.CURRENT) {
            selectedAllCurrent ? setNewCurrent([]) : setNewCurrent(
                current.map(listItem => listItem.userIdentifier ? listItem.userIdentifier : listItem.code ?
                    listItem.code : listItem.name ? listItem.name : listItem)
            );
        } else {
            selectedAllOptions ? setNewOptions([]) : setNewOptions(
                options.map(listItem => listItem.userIdentifier ? listItem.userIdentifier :
                    listItem.code ? listItem.code :
                        listItem.name ? listItem.name :
                            listItem)
            );
        }
    };

    const handleListChange = () => {

        // Remove/add new items from individual lists
        setCurrent(current
            .filter(current => !newCurrent
                .find(newCurrentItem => (newCurrentItem === (current.userIdentifier ? current.userIdentifier :
                    current.code ? current.code : current.name ? current.name : current)))));

        setOptions(options
            .filter(option => !newOptions
                .find(newOptionsItem => (newOptionsItem === (option.userIdentifier ? option.userIdentifier :
                    option.code ? option.code : option.name ? option.name : option)))));

        // Merge updated lists
        setOptions(options => [...options, ...current
            .filter(current => newCurrent
                .find(newCurrentItem => (newCurrentItem === (current.userIdentifier ? current.userIdentifier :
                    current.code ? current.code : current.name ? current.name : current))))
            .map(current => current)]);

        setCurrent(current => [...current, ...options
            .filter(option => newOptions
                .find(newOptionsItem => (newOptionsItem === (option.userIdentifier ? option.userIdentifier :
                    option.code ? option.code : option.name ? option.name : option))))
            .map(options => options)]);

        // Reset new items
        setNewCurrent([]);
        setNewOptions([]);

        setChangesMade(true);
    };

    return (
        <div className="grid grid-flow-col grid-col-dense gap-10">
            <div>
                <div className={
                    "text-sm text-sm font-medium text-indigo-900 w-full mb-2 grid grid-flow-col " +
                    "space-between"
                }>
                    <span>Current {itemName}</span>
                </div>
                <p className="text-sm text-gray-600">
                    Click on {itemName} to mark for removal
                </p>
                <div className={
                    "grid grid-flow-row auto-rows-min gap-4 py-3 overflow-y-scroll relative " +
                    "transition-all mt-2 pr-2 overflow-x-hidden overflow-y-auto " +
                    (current.length > 4 || options.length > 4 ? "h-96" : "h-80")
                }>

                    {current.slice(0).reverse().map((listItem) => {
                        const elementId = listItem.userIdentifier ? listItem.userIdentifier :
                            listItem.code ? listItem.code :
                                listItem.name ? listItem.name : listItem;
                        return <CheckboxCard
                            id={elementId}
                            key={elementId}
                            listItem={listItem}
                            checked={newCurrent.includes(elementId)}
                            onChange={onCheckboxClick}
                            type={SELECT_TYPES.CURRENT}
                        />;
                    })
                    }

                </div>
                <div className={"grid grid-flow-col space-between mt-6"}>
                    <div>
                        <div
                            className={"text-xs font-medium text-secondary-600 w-max"}>
                            {newCurrent.length}/{current.length} selected
                        </div>
                    </div>
                    <div className={"text-right"}>
                        <Button
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            text={selectedAllCurrent ? "Deselect all" : "Select all"}
                            extraStyling="shadow-none text-xs text-primary-600 p-0 float-right"
                            onClick={() => onSelectAllClick(SELECT_TYPES.CURRENT)}
                        />
                    </div>
                </div>
            </div>
            <div className={"justify-center items-center flex"}>
                <Button
                    icon={<SwitchHorizontalIcon className="block h-12 w-12"/>}
                    iconPositionLeft
                    onClick={handleListChange}
                    disabled={newCurrent.length === 0 && newOptions.length === 0}
                    extraStyling={
                        "text-white focus:ring-inset focus:ring-1 bg-primary-600 hover:bg-primary-700 " +
                        "focus:outline-none focus:ring-primary-600 rounded-full h-12 w-12 items-center " +
                        "justify-center p-3"
                    }
                />
            </div>
            <div>
                <div className={
                    "text-sm text-sm font-medium text-indigo-900 w-full mb-2 grid grid-flow-col " +
                    "space-between"
                }>
                    <span>Available {itemName}</span>
                </div>
                <p className="text-sm text-gray-600">
                    Click on {itemName} to mark for addition
                </p>
                <div className={
                    "grid grid-flow-row auto-rows-min gap-4 py-3 overflow-y-scroll relative " +
                    "transition-all rounded-lg mt-2 pr-2 scrollbar overflow-x-hidden overflow-y-auto " +
                    (current.length > 4 || options.length > 4 ? "h-96" : "h-80")
                }>

                    {options.slice(0).reverse().map((listItem) => {
                        const elementId = listItem.userIdentifier ? listItem.userIdentifier :
                            listItem.code ? listItem.code :
                                listItem.name ? listItem.name :
                                    listItem;
                        return <CheckboxCard
                            id={elementId}
                            key={elementId}
                            listItem={listItem}
                            onChange={onCheckboxClick}
                            checked={newOptions.includes(elementId)}
                            type={SELECT_TYPES.OPTION}
                        />;
                    })}

                </div>
                <div className={"grid grid-flow-col space-between mt-6"}>
                    <div>
                        <div
                            className={"text-xs font-medium text-secondary-600 w-max"}>
                            {newOptions.length}/{options.length} selected
                        </div>
                    </div>
                    <div className={"text-right"}>
                        <Button
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            text={selectedAllOptions ? "Deselect all" : "Select all"}
                            extraStyling="shadow-none text-primary-600 text-xs p-0 float-right"
                            onClick={() => onSelectAllClick(SELECT_TYPES.OPTION)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DualList;
